module.exports = __webpack_public_path__ + "static/maxim-d7748397d6dc83e940ed5a76d94677f6.jpg";